import React from 'react';
import classNames from 'classnames';

import css from './IconVerifiedCheck.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconVerifiedCheck = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0418 5.18768C13.7936 4.54697 14.1695 4.22662 14.5626 4.03876C15.4716 3.60427 16.5284 3.60427 17.4375 4.03876C17.8305 4.22662 18.2064 4.54697 18.9583 5.18768C19.2575 5.44268 19.4071 5.57018 19.5669 5.67728C19.9332 5.92278 20.3445 6.09317 20.7771 6.17858C20.9658 6.21583 21.1618 6.23147 21.5537 6.26275C22.5384 6.34132 23.0307 6.38061 23.4415 6.52569C24.3915 6.86126 25.1388 7.60853 25.4743 8.55857C25.6194 8.96933 25.6587 9.46166 25.7373 10.4463C25.7686 10.8382 25.7842 11.0342 25.8215 11.2229C25.9069 11.6555 26.0772 12.0669 26.3228 12.4331C26.4298 12.5929 26.5573 12.7425 26.8124 13.0418C27.4531 13.7936 27.7734 14.1695 27.9613 14.5626C28.3958 15.4716 28.3958 16.5284 27.9613 17.4375C27.7734 17.8305 27.4531 18.2064 26.8124 18.9583C26.5573 19.2575 26.4298 19.4071 26.3228 19.5669C26.0772 19.9332 25.9069 20.3445 25.8215 20.7771C25.7842 20.9658 25.7686 21.1618 25.7373 21.5537C25.6587 22.5384 25.6194 23.0307 25.4743 23.4415C25.1388 24.3915 24.3915 25.1388 23.4415 25.4743C23.0307 25.6194 22.5384 25.6587 21.5537 25.7373C21.1618 25.7686 20.9658 25.7842 20.7771 25.8215C20.3445 25.9069 19.9332 26.0772 19.5669 26.3228C19.4071 26.4298 19.2575 26.5573 18.9583 26.8124C18.2064 27.4531 17.8305 27.7734 17.4375 27.9613C16.5284 28.3958 15.4716 28.3958 14.5626 27.9613C14.1695 27.7734 13.7936 27.4531 13.0418 26.8124C12.7425 26.5573 12.5929 26.4298 12.4331 26.3228C12.0669 26.0772 11.6555 25.9069 11.2229 25.8215C11.0342 25.7842 10.8382 25.7686 10.4463 25.7373C9.46166 25.6587 8.96933 25.6194 8.55857 25.4743C7.60853 25.1388 6.86126 24.3915 6.52569 23.4415C6.38061 23.0307 6.34132 22.5384 6.26275 21.5537C6.23147 21.1618 6.21583 20.9658 6.17858 20.7771C6.09317 20.3445 5.92278 19.9332 5.67728 19.5669C5.57018 19.4071 5.44268 19.2575 5.18768 18.9583C4.54697 18.2064 4.22662 17.8305 4.03876 17.4375C3.60427 16.5284 3.60427 15.4716 4.03876 14.5626C4.22662 14.1695 4.54697 13.7936 5.18768 13.0418C5.44268 12.7425 5.57018 12.5929 5.67728 12.4331C5.92278 12.0669 6.09317 11.6555 6.17858 11.2229C6.21583 11.0342 6.23147 10.8382 6.26275 10.4463C6.34132 9.46166 6.38061 8.96933 6.52569 8.55857C6.86126 7.60854 7.60854 6.86126 8.55857 6.52569C8.96933 6.38061 9.46166 6.34132 10.4463 6.26275C10.8382 6.23147 11.0342 6.21583 11.2229 6.17858C11.6555 6.09317 12.0669 5.92278 12.4331 5.67728C12.5929 5.57018 12.7425 5.44268 13.0418 5.18768Z"
        stroke="#113A69"
        stroke-width="1.5"
      />
      <path
        d="M11.334 16.6667L14.0007 19.3334L20.6673 12.6667"
        stroke="#113A69"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default IconVerifiedCheck;
